import { autoMount } from '../../../utils/autoMount';
import { PickupCompanies } from '../../../components/organisms/pickupCompanies';

autoMount({ PickupCompanies });
